 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"HomeHeaderAdmin":"HomeHeaderAdmin","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358":"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8":"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8","admcupom~admperfis~admservices":"admcupom~admperfis~admservices","admperfis":"admperfis","admservices":"admservices","messages":"messages","storage":"storage","Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c":"Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c","Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress":"Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress","Scheduling":"Scheduling","admagendamentos":"admagendamentos","admusers":"admusers","contact":"contact","scheduled":"scheduled","admcupom":"admcupom","pendingrecord":"pendingrecord","agenda":"agenda","home-desktop~perfil~register~servicesaddress":"home-desktop~perfil~register~servicesaddress","newperfil~perfil~register":"newperfil~perfil~register","register":"register","uploadeula~uploadfile":"uploadeula~uploadfile","uploadfile":"uploadfile","perfil":"perfil","newperfil":"newperfil","sessionresume":"sessionresume","uploadeula":"uploadeula","record":"record","servicesperformed":"servicesperformed","servicesaddress":"servicesaddress","TokenExpired":"TokenExpired","about":"about","appointservices":"appointservices","benefits":"benefits","confirm":"confirm","dashboard":"dashboard","faq":"faq","home":"home","learnmore":"learnmore","login":"login","loginAdmin":"loginAdmin","newPassword":"newPassword","operation":"operation","passwordreset":"passwordreset","professionalscheduled":"professionalscheduled","reset":"reset","selectperfil":"selectperfil","services":"services","signin":"signin","teste":"teste","userrating":"userrating","perfil-select":"perfil-select","home-desktop":"home-desktop","home-mobile":"home-mobile","ProfDescriptionSlide":"ProfDescriptionSlide","Security":"Security","VideoDialog":"VideoDialog","video-slide":"video-slide"}[chunkId]||chunkId) + "." + {"HomeHeaderAdmin":"96efff6e","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358":"0893f20c","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8":"8b0aa54a","admcupom~admperfis~admservices":"f0883227","admperfis":"667a3b3a","admservices":"378773f0","messages":"b0195d53","storage":"0d973e95","Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c":"55ee443e","Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress":"baf6f0f6","Scheduling":"bb28037e","admagendamentos":"f1706588","admusers":"d088a7aa","contact":"61a7b742","scheduled":"94a13ed3","admcupom":"49c81f61","pendingrecord":"dc3c933d","agenda":"c38108d0","home-desktop~perfil~register~servicesaddress":"43cd3eac","newperfil~perfil~register":"a4f28426","register":"8f0d3bb9","uploadeula~uploadfile":"cb050879","uploadfile":"e6ecd57b","perfil":"dd784a20","newperfil":"b20b8e84","sessionresume":"2d97ea75","uploadeula":"56481a7a","record":"27009b2a","servicesperformed":"b4d87124","servicesaddress":"3e088354","TokenExpired":"aec2388d","about":"984af3c9","appointservices":"bb22fe4d","benefits":"7cb7ee59","confirm":"4b8354b7","dashboard":"a96f7171","faq":"833830ae","home":"3e9687dc","learnmore":"6550064c","login":"569e8cb3","loginAdmin":"a52d654c","newPassword":"78de3312","operation":"b8b55a40","passwordreset":"84fc52e3","professionalscheduled":"d3af240d","reset":"00a7f381","selectperfil":"791d0e45","services":"faeb3fb6","signin":"110ded1b","teste":"b5e7be5d","userrating":"d96f84cd","perfil-select":"4954f1b0","home-desktop":"a25632fe","home-mobile":"352607ba","ProfDescriptionSlide":"aedc1f39","Security":"0e44de7b","VideoDialog":"8725b936","video-slide":"b3f6e462"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"HomeHeaderAdmin":1,"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358":1,"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8":1,"admcupom~admperfis~admservices":1,"admperfis":1,"admservices":1,"messages":1,"storage":1,"Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c":1,"Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress":1,"Scheduling":1,"admagendamentos":1,"admusers":1,"contact":1,"scheduled":1,"admcupom":1,"pendingrecord":1,"agenda":1,"newperfil~perfil~register":1,"register":1,"uploadeula~uploadfile":1,"uploadfile":1,"perfil":1,"newperfil":1,"sessionresume":1,"uploadeula":1,"record":1,"servicesperformed":1,"servicesaddress":1,"TokenExpired":1,"about":1,"appointservices":1,"benefits":1,"confirm":1,"dashboard":1,"faq":1,"learnmore":1,"login":1,"loginAdmin":1,"newPassword":1,"operation":1,"passwordreset":1,"professionalscheduled":1,"reset":1,"selectperfil":1,"services":1,"signin":1,"userrating":1,"perfil-select":1,"home-desktop":1,"home-mobile":1,"ProfDescriptionSlide":1,"video-slide":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"HomeHeaderAdmin":"HomeHeaderAdmin","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358":"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8":"Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8","admcupom~admperfis~admservices":"admcupom~admperfis~admservices","admperfis":"admperfis","admservices":"admservices","messages":"messages","storage":"storage","Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c":"Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c","Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress":"Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress","Scheduling":"Scheduling","admagendamentos":"admagendamentos","admusers":"admusers","contact":"contact","scheduled":"scheduled","admcupom":"admcupom","pendingrecord":"pendingrecord","agenda":"agenda","home-desktop~perfil~register~servicesaddress":"home-desktop~perfil~register~servicesaddress","newperfil~perfil~register":"newperfil~perfil~register","register":"register","uploadeula~uploadfile":"uploadeula~uploadfile","uploadfile":"uploadfile","perfil":"perfil","newperfil":"newperfil","sessionresume":"sessionresume","uploadeula":"uploadeula","record":"record","servicesperformed":"servicesperformed","servicesaddress":"servicesaddress","TokenExpired":"TokenExpired","about":"about","appointservices":"appointservices","benefits":"benefits","confirm":"confirm","dashboard":"dashboard","faq":"faq","home":"home","learnmore":"learnmore","login":"login","loginAdmin":"loginAdmin","newPassword":"newPassword","operation":"operation","passwordreset":"passwordreset","professionalscheduled":"professionalscheduled","reset":"reset","selectperfil":"selectperfil","services":"services","signin":"signin","teste":"teste","userrating":"userrating","perfil-select":"perfil-select","home-desktop":"home-desktop","home-mobile":"home-mobile","ProfDescriptionSlide":"ProfDescriptionSlide","Security":"Security","VideoDialog":"VideoDialog","video-slide":"video-slide"}[chunkId]||chunkId) + "." + {"HomeHeaderAdmin":"0d1a1769","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~agenda~contact~home-desktop~messa~f624a358":"10104fe4","Scheduling~admagendamentos~admcupom~admperfis~admservices~admusers~contact~messages~pendingrecord~sc~f88edba8":"9f513c3c","admcupom~admperfis~admservices":"446b3abb","admperfis":"3866d57c","admservices":"8d43648e","messages":"ff754f8d","storage":"11c61ae3","Scheduling~admagendamentos~admcupom~admusers~agenda~contact~home-desktop~pendingrecord~record~regist~8af6390c":"6aa76c4d","Scheduling~admagendamentos~admusers~agenda~contact~scheduled~servicesaddress":"13654861","Scheduling":"8b7e0d8a","admagendamentos":"7e55bd6f","admusers":"ac3106a7","contact":"8eac967b","scheduled":"d3936ab4","admcupom":"8db8ca8d","pendingrecord":"ef50772b","agenda":"2a87bba5","home-desktop~perfil~register~servicesaddress":"31d6cfe0","newperfil~perfil~register":"536ad13c","register":"978db7c9","uploadeula~uploadfile":"911aef3c","uploadfile":"10494461","perfil":"b5560c33","newperfil":"4a7bc95f","sessionresume":"26c704ed","uploadeula":"f0d501d2","record":"20df6be1","servicesperformed":"5688b3cc","servicesaddress":"d3c062ba","TokenExpired":"d43936dd","about":"4733b3db","appointservices":"b791d523","benefits":"a170d964","confirm":"0e5b72b8","dashboard":"298442d2","faq":"e572c829","home":"31d6cfe0","learnmore":"ddcaf44f","login":"08a0e765","loginAdmin":"b7939de9","newPassword":"3a494df7","operation":"e37a3398","passwordreset":"13654861","professionalscheduled":"e2289743","reset":"38290c24","selectperfil":"b4742ac8","services":"4a7623ab","signin":"11dd390f","teste":"31d6cfe0","userrating":"14d6e022","perfil-select":"b4742ac8","home-desktop":"11a21cec","home-mobile":"593b2245","ProfDescriptionSlide":"ba80baf8","Security":"31d6cfe0","VideoDialog":"31d6cfe0","video-slide":"f4dc64ca"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
